import React, { useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Only same-site paths: "/photos" yes, "//evil.example" and "https://..." no.
export const safeNext = (next) =>
  typeof next === 'string' && next.startsWith('/') && !next.startsWith('//') ? next : '/profile';

// Landing page for the sign-in link in an activation reminder email. The
// one-time token is exchanged only when the person clicks Continue: mail
// link scanners load the page and run its JS, and must not burn the link.
export default function ActivationSigninPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithActivationToken } = useAuth();
  const [expired, setExpired] = useState(!searchParams.get('token'));
  const [busy, setBusy] = useState(false);
  const submitted = useRef(false);

  const onContinue = () => {
    if (submitted.current) return; // single-use token: never exchange twice
    submitted.current = true;
    setBusy(true);
    loginWithActivationToken(searchParams.get('token'))
      .then(() => navigate(safeNext(searchParams.get('next')), { replace: true }))
      .catch(() => setExpired(true));
  };

  if (expired) {
    return (
      <div role="alert" style={{ maxWidth: 420, margin: '80px auto', padding: '0 16px', textAlign: 'center' }}>
        <p>This link has expired or was already used.</p>
        {/* These accounts never chose a password: setting one is the way in. */}
        <p><Link to="/forgot-password">Set a password to sign in</Link></p>
      </div>
    );
  }
  return (
    <div style={{ maxWidth: 420, margin: '80px auto', padding: '0 16px', textAlign: 'center' }}>
      <h1 style={{ fontSize: 24 }}>Welcome to ProZpects</h1>
      <button type="button" onClick={onContinue} disabled={busy}>
        Continue to ProZpects
      </button>
    </div>
  );
}
